export default __webpack_public_path__ + "static/tdic-es-69cda35923ae6075e062c8f8eb76c4a6.mp4";